import { Mutation } from 'vuex'
import { MediaLibraryState } from '../types'
import {
  MediaLibraryEssence,
  MediaLibraryImageItem,
} from '@/types/mediaLibrary'

const setImagesMediaLibrary: Mutation<MediaLibraryState> = (
  state,
  {
    essence,
    images,
  }: { essence: MediaLibraryEssence; images: MediaLibraryImageItem[] }
) => {
  const mediaLibrary = new Map(state.value)
  const mediaLibraryItem = mediaLibrary.get(essence)

  if (mediaLibraryItem) {
    const newImages = images.filter(
      (image) =>
        !mediaLibraryItem.images.some(
          (existingImage) => existingImage.id === image.id
        )
    )
    mediaLibraryItem.images = [...mediaLibraryItem.images, ...newImages]

    state.value = mediaLibrary
  }
}

export default setImagesMediaLibrary
